import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, ConfigProviderProps } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';

import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
type Locale = ConfigProviderProps['locale'];

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          components: {
            Button: {
              colorPrimary: '#F4B64D',
              defaultHoverColor: '#fff',
              defaultHoverBg: '#F4B64D',
              defaultHoverBorderColor: '#F4B64D',
              defaultColor: '#fff',
              defaultActiveColor: '#fff',
              defaultActiveBg: '#F4B64D',
              defaultActiveBorderColor: '#F4B64D',
              defaultBg: '#F4B64D',
            },
            Tabs: {
              inkBarColor: '#F4B64D',
              itemActiveColor: '#F4B64D',
              itemHoverColor: '#333333',
              itemSelectedColor: '#333333',
            },
            DatePicker: {
              activeBorderColor: '#F4B64D',
              hoverBorderColor: '#F4B64D',
              cellRangeBorderColor: '#F4B64D',
            },
          },
          token: {
            colorPrimary: '#F4B64D',
          },
        }}
        locale={zhCN}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
